import { IScheduleStreamContentBulkActionPayload } from '../interfaces/schedule-stream-content-bulk.action-payload.interface';

export class CreateScheduledStreamContentBulkCommand {
    audience_id: number;
    featured_stream_id: number;
    posting_ids: number[];

    constructor(query: IScheduleStreamContentBulkActionPayload) {
        this.audience_id = Number(query.audience.id);
        this.featured_stream_id = Number(query.featuredStream.id);
        this.posting_ids = query.postingIds;
    }
}
